import { appLoader } from '@/_core/app-components/use';
import VueRouter, { Route, isNavigationFailure, NavigationFailureType } from 'vue-router';

export async function goToExternalUrl(url: string, isNewTab: boolean = false, shouldShowLoader: boolean = true) {
    if (isNewTab) {
        window.open(url, '_blank');
    } else {
        if (shouldShowLoader) appLoader.open(0);
        location.href = url;
    }
}

export async function goToLogout() {
    window.location.href = initAppData.appUrls.logoutUrl.toLowerCase();
}

/**
 * Navigate safely without NavigationDuplicated errors
 * @param router The Vue Router instance
 * @param location Target location
 * @returns Promise from navigation
 */
export function navigateSafely(router: VueRouter, location: string): Promise<Route> {
    const target = router.resolve(location).route; // normalized
    if (target.fullPath === router.currentRoute.fullPath) {
        return Promise.resolve(router.currentRoute);
    }

    return router.push(location).catch((err) => {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
            return router.currentRoute;
        }
        throw err; // don’t swallow real errors
    });
}
